"use strict";
/* eslint-disable camelcase */
/*
 *
 *  When using constants which has enums, prefer to use enums. Constants are only for backward compatibility.
 *
 * */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIBRARY_DIR_DEPTH = exports.VERSION_STATUS = exports.CLIENT_TYPES = exports.PLATFORM_TYPES = exports.INVITE_STARTED_FROM = exports.REDIRECTABLE_APPLICATIONS = exports.ONBOARDING_MODE = exports.RESOURCE_TYPES = exports.DEFAULT_SELF_CLOSING_HTML_TAGS = exports.DEFAULT_WHITELISTED_HTML_TAGS = exports.SENTRY_DOMAINS = exports.DEFAULT_FE = exports.ADMIN_SUBDOMAINS = exports.APPS_SUBDOMAINS = exports.SDK_SUBDOMAINS = exports.SUBDOMAINS = exports.WT_SUFFIX = exports.DSLP_PREFIX = exports.AI_PREFFIX = exports.STATS_PREFFIX = exports.API_SUFFIX = exports.PORT_SEPARATOR = exports.CREDENTIALS_SEPARATOR = exports.SCHEME_SEPARATOR = exports.HTTP = exports.HTTPS = exports.PasswordErrorType = exports.VersionStatus = exports.InviteStartedFrom = exports.RedirectableApplications = exports.OnboardingMode = exports.OCRType = exports.ResourceType = exports.DeviceCategory = exports.ClientType = exports.PlatformType = exports.CODE_PLACEHOLDER = exports.URL_PLACEHOLDER = exports.FE_SUBDOMAIN_PLACEHOLDER = exports.DASHBOARD_CLIENT_URL = exports.MOBILE_CLIENT_URL = exports.HOST_SUFFIX = exports.DOMAIN_PLACEHOLDER = exports.HOST_PLACEHOLDER = void 0;
exports.HOST_PLACEHOLDER = '{hostname}';
exports.DOMAIN_PLACEHOLDER = '{domain}';
exports.HOST_SUFFIX = '.techsee.me';
exports.MOBILE_CLIENT_URL = 'https://{feSubDomain}.techsee.me/app/';
exports.DASHBOARD_CLIENT_URL = 'https://{feSubDomain}.techsee.me';
exports.FE_SUBDOMAIN_PLACEHOLDER = '{feSubDomain}';
exports.URL_PLACEHOLDER = '{{url}}';
exports.CODE_PLACEHOLDER = '{{code}}';
//TODO - CR: Need to consolidate PlatformType and ClientType enums, looks like it's the same context
var PlatformType;
(function (PlatformType) {
    PlatformType["admin"] = "admin";
    PlatformType["dashboard"] = "dashboard";
    PlatformType["mobile_web"] = "MOBILE_WEB";
    PlatformType["desktop_web"] = "DESKTOP_WEB";
    PlatformType["mobile_native"] = "APPLICATION";
    PlatformType["sdk"] = "SDK";
    PlatformType["sdk_ios"] = "SDK_IOS";
    PlatformType["sdk_android"] = "SDK_ANDROID";
    PlatformType["eve"] = "EVE";
    PlatformType["dynamicAppClient"] = "DYNAMIC_APP_CLIENT";
    PlatformType["livePointer"] = "LIVE_POINTER";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
//IMPORTANT: THIS ENUM IS DEPRECATED, USE PlatformType ENUM INSTEAD
var ClientType;
(function (ClientType) {
    ClientType["web"] = "MOBILE_WEB";
    ClientType["desktop_web"] = "DESKTOP_WEB";
    ClientType["native"] = "APPLICATION";
    ClientType["sdk"] = "SDK";
    ClientType["sdk_ios"] = "SDK_IOS";
    ClientType["sdk_android"] = "SDK_ANDROID";
    ClientType["eve"] = "EVE";
    ClientType["dynamicAppClient"] = "DYNAMIC_APP_CLIENT";
    ClientType["livePointer"] = "LIVE_POINTER";
})(ClientType = exports.ClientType || (exports.ClientType = {}));
var DeviceCategory;
(function (DeviceCategory) {
    DeviceCategory["desktop"] = "desktop";
    DeviceCategory["phone"] = "phone";
    DeviceCategory["tablet"] = "tablet";
})(DeviceCategory = exports.DeviceCategory || (exports.DeviceCategory = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["video"] = "VIDEO";
    ResourceType["image"] = "IMAGE";
    ResourceType["pdf"] = "PDF";
    ResourceType["www"] = "WWW";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var OCRType;
(function (OCRType) {
    OCRType["barcode"] = "Barcode";
    OCRType["qrCode"] = "QR Code";
    OCRType["text"] = "text";
})(OCRType = exports.OCRType || (exports.OCRType = {}));
var OnboardingMode;
(function (OnboardingMode) {
    OnboardingMode["invite"] = "invite";
    OnboardingMode["wizard"] = "wizard";
    OnboardingMode["terms"] = "terms";
    OnboardingMode["camera_approval"] = "camera";
    OnboardingMode["imgupload"] = "imgupload";
})(OnboardingMode = exports.OnboardingMode || (exports.OnboardingMode = {}));
var RedirectableApplications;
(function (RedirectableApplications) {
    RedirectableApplications["SELF_SERVICE_V1"] = "lieve";
    RedirectableApplications["SELF_SERVICE_V2"] = "eve";
})(RedirectableApplications = exports.RedirectableApplications || (exports.RedirectableApplications = {}));
var InviteStartedFrom;
(function (InviteStartedFrom) {
    InviteStartedFrom["DESKTOP_LAUNCHER"] = "dl";
    InviteStartedFrom["INVITE_WIZARD"] = "iw";
})(InviteStartedFrom = exports.InviteStartedFrom || (exports.InviteStartedFrom = {}));
var VersionStatus;
(function (VersionStatus) {
    VersionStatus["VALID"] = "valid";
    VersionStatus["INVALID"] = "invalid";
    VersionStatus["DEPRECATED"] = "deprecated";
})(VersionStatus = exports.VersionStatus || (exports.VersionStatus = {}));
var PasswordErrorType;
(function (PasswordErrorType) {
    PasswordErrorType["passwordMismatch"] = "PASSWORD_MISMATCH";
    PasswordErrorType["usedPassword"] = "USED_PASSWORD";
})(PasswordErrorType = exports.PasswordErrorType || (exports.PasswordErrorType = {}));
exports.HTTPS = 'https://';
exports.HTTP = 'http://';
exports.SCHEME_SEPARATOR = '://';
exports.CREDENTIALS_SEPARATOR = '@';
exports.PORT_SEPARATOR = ':';
exports.API_SUFFIX = '-api';
exports.STATS_PREFFIX = 'stats-';
exports.AI_PREFFIX = 'ai-';
exports.DSLP_PREFIX = 'dslp-';
exports.WT_SUFFIX = '-wt';
exports.SUBDOMAINS = {
    app: 'api',
    app1: 'api1',
    'preprod-apps': 'preprod-api',
    'preprod-apps1': 'preprod-api1',
    stagings: 'staging-api',
    rcs: 'rc-api',
    tests: 'test-api',
    pretests: 'pretest-api',
    hagrids: 'hagrid-api',
    app2: 'api2',
    'vf-pt': 'vf-pt-api1',
    app4: 'api4',
    app5: 'api5',
    app6: 'api6',
    'preprod-app': 'preprod-api',
    'preprod-app1': 'preprod-api1',
    'preprod-app6': 'preprod-api6'
};
exports.SDK_SUBDOMAINS = {
    staging: 'staging-api',
    rc: 'rc-api',
    test: 'test-api',
    pretest: 'pretest-api',
    hagrid: 'hagrid-api',
    play: 'play-api',
    int: 'int-api',
    demo: 'demo-api',
    'pt-tc': 'api1',
    hot: 'api1',
    samch: 'api1',
    wind3: 'api1',
    upcpl: 'api1',
    vmie: 'api1',
    skyit: 'api1',
    orange: 'api1',
    umde: 'api1',
    'vf-gr': 'api1',
    philips: 'api1',
    andersen: 'api',
    telia: 'api1',
    sfrnc: 'api1',
    tigo: 'api',
    achmea: 'achmea-api',
    'orange-es': 'api1',
    vziggo: 'api1',
    'sam-mx': 'api',
    'tf-pe': 'tf-pe-api',
    lavazza: 'api1',
    bezeq: 'api',
    '360': 'rc-api',
    'vc-za': 'vc-za-api',
    'sam-uk': 'api1',
    'vf-nz': 'api',
    rost: 'api1',
    evides: 'api1',
    bytel: 'api1',
    bouygt: 'api1',
    eve: 'test-api',
    a1aus: 'api1',
    tpv: 'api1',
    'ntt-e': 'api',
    frontier: 'api',
    ais: 'demo-api',
    samfr: 'api1',
    skyuk: 'api1',
    pmi: 'api1',
    kng: 'api1',
    innogy: 'api1',
    pomoc: 'api1',
    nowo: 'api1',
    'tigo-hn': 'tigo-hn-api',
    'tigo-py': 'tigo-py-api',
    'tigo-bo': 'tigo-bo-api',
    'tigo-sv': 'tigo-sv-api',
    'tigo-cr': 'tigo-cr-api',
    sb: 'api',
    cmdus: 'api',
    sb1: 'api1',
    cmdeu: 'api1',
    vfuk: 'api1',
    blue: 'blue-api',
    domru: 'domru-api',
    algar: 'algar-api',
    'vf-it': 'vf-it-api',
    'vf-es': 'vf-es-api',
    'preprod-vf-pt': 'preprod-vf-pt-api',
    comcast: 'api'
};
exports.APPS_SUBDOMAINS = {
    apps: 'api',
    apps1: 'api1',
    'preprod-apps': 'preprod-api',
    'preprod-apps1': 'preprod-api1',
    stagings: 'staging-api',
    rcs: 'rc-api',
    tests: 'test-api',
    pretests: 'pretest-api',
    hagrids: 'hagrid-api',
    comcast: 'api',
    frontier: 'api'
};
exports.ADMIN_SUBDOMAINS = {
    app: 'admin',
    app1: 'admin1',
    'preprod-app': 'preprod-admin',
    'preprod-app1': 'preprod-admin1',
    'preprod-app6': 'preprod-admin6',
    app4: 'admin4',
    app5: 'admin5',
    app6: 'admin6'
};
exports.DEFAULT_FE = {
    api: 'app',
    api1: 'app1',
    api2: 'app2',
    'vf-pt-api1': 'vf-pt',
    api4: 'app4',
    api5: 'app5',
    api6: 'app6',
    'preprod-api': 'preprod-app',
    'preprod-api1': 'preprod-app1',
    'preprod-api6': 'preprod-app6',
    'preprod-vf-pt-api': 'preprod-vf-pt',
    'vf-es-api': 'vf-es',
    'vc-za-api': 'vc-za',
    'achmea-api': 'achmea',
    'domru-api': 'domru',
    'algar-api': 'algar',
    'vf-it-api': 'vf-it'
};
exports.SENTRY_DOMAINS = {
    'vf-pt': 'sentry-mob-vf-pt.techsee.me',
    'vf-es': 'sentry-mob-vf-es.techsee.me',
    'tf-pe': 'sentry-mob-tf-pe.techsee.me',
    'vc-za': 'sentry-mob-vc-za.techsee.me',
    'tigo-hn': 'sentry-mob-tigo-hn.techsee.me',
    'tigo-py': 'sentry-mob-tigo-py.techsee.me',
    'tigo-bo': 'sentry-mob-tigo-bo.techsee.me',
    'tigo-sv': 'sentry-mob-tigo-sv.techsee.me',
    'tigo-cr': 'sentry-mob-tigo-cr.techsee.me',
    blue: 'sentry-mob-blue.techsee.me',
    algar: 'sentry-mob-algar.techsee.me',
    'vf-it': 'sentry-mob-vf-it.techsee.me',
    pomoc: 'sentry-mob-pomoc.techsee.me',
    vmuk: 'sentry-mob-vmuk.techsee.me',
    att: 'sentry-mob-att.techsee.me'
};
exports.DEFAULT_WHITELISTED_HTML_TAGS = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'br',
    'sub',
    'sup',
    'p',
    'a',
    'ul',
    'ol',
    'li',
    'div',
    'span',
    'b',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'footer',
    'header',
    'main',
    'nav'
];
exports.DEFAULT_SELF_CLOSING_HTML_TAGS = ['hr', 'br', 'link', 'img'];
exports.RESOURCE_TYPES = ResourceType;
exports.ONBOARDING_MODE = OnboardingMode;
exports.REDIRECTABLE_APPLICATIONS = RedirectableApplications;
exports.INVITE_STARTED_FROM = InviteStartedFrom;
exports.PLATFORM_TYPES = PlatformType;
exports.CLIENT_TYPES = ClientType;
exports.VERSION_STATUS = VersionStatus;
exports.LIBRARY_DIR_DEPTH = 3;

//# sourceMappingURL=utils.constant.js.map
